<template>
  <div id="form">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        Schallrichtung und Entfernung können durch Binaurales Hören bestimmt werden, 
        diese Funktion ist ebenfalls Außenohren zuzuschreiben.
    </p>
    <p style="text-align: left;">
        Diese Bestimmung erfolgt durch <input v-model="message1" placeholder="Feld1" /> (ITDs) 
        und <input v-model="message2" placeholder="Feld2" /> (ILDs). 
    </p>

    <button id="button2" v-on:click="check">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message1: '',
        message2: '',
        // message3: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check() {
        if ( ((this.message1 && this.message1 == "Zeitdifferenzen" || this.message1 == "zeitdifferenzen") &&
             (this.message2 && this.message2 == "Pegeldifferenzen" || this.message2 == "pegeldifferenzen"))
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "aufbauForm2_done", state: true})
                localStorage.setItem("aufbauForm2_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */

#button2 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form {
    height: 1000px;;
}
</style>